import React from "react";
import { Box, Container, Skeleton, styled } from "@mui/material";

const SkeletonWrapper = styled(Box)(({ theme }) => ({
  background: "linear-gradient(135deg, #1E1E1E 0%, #2D2D2D 100%)",
  position: "relative",
  overflow: "hidden",
  minHeight: "500px",
  color: "#fff",
  "&::after": {
    content: '""',
    position: "absolute",
    top: 0,
    right: 0,
    width: "40%",
    height: "100%",
    background: "linear-gradient(135deg, #FF4C00 0%, #FF8A00 100%)",
    transform: "skewX(-15deg) translateX(10%)",
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  },
}));

const ContentWrapper = styled(Container)(({ theme }) => ({
  position: "relative",
  zIndex: 1,
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  minHeight: "500px",
  gap: theme.spacing(8),
  padding: theme.spacing(4, 6),
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
    padding: theme.spacing(4, 2),
    gap: theme.spacing(4),
  },
}));

const TextContent = styled(Box)(({ theme }) => ({
  flex: "0 0 50%",
  maxWidth: "550px",
  paddingTop: theme.spacing(4),
  paddingBottom: theme.spacing(4),
  [theme.breakpoints.down("md")]: {
    flex: "1 1 auto",
    textAlign: "center",
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    maxWidth: "100%",
  },
}));

const ImageContent = styled(Box)(({ theme }) => ({
  flex: "0 0 45%",
  position: "relative",
  zIndex: 2,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  [theme.breakpoints.down("md")]: {
    flex: "1 1 auto",
    width: "100%",
    maxWidth: "320px",
    margin: "0 auto",
  },
}));

const HeroSkeleton = () => {
  return (
    <SkeletonWrapper>
      <ContentWrapper maxWidth="xl">
        <TextContent>
          <Skeleton
            variant="rectangular"
            width="80%"
            height={60}
            sx={{
              mb: 2,
              bgcolor: "rgba(255, 255, 255, 0.1)",
              borderRadius: 1,
            }}
          />
          <Skeleton
            variant="rectangular"
            width="60%"
            height={40}
            sx={{
              mb: 2,
              bgcolor: "rgba(255, 255, 255, 0.1)",
              borderRadius: 1,
            }}
          />
          <Skeleton
            variant="rectangular"
            width="100%"
            height={80}
            sx={{
              mb: 3,
              bgcolor: "rgba(255, 255, 255, 0.1)",
              borderRadius: 1,
            }}
          />
          <Skeleton
            variant="rectangular"
            width={200}
            height={50}
            sx={{
              bgcolor: "rgba(255, 255, 255, 0.1)",
              borderRadius: 25,
            }}
          />

          <Box sx={{ mt: 6, width: "100%" }}>
            <Skeleton
              variant="rectangular"
              width="100%"
              height={48}
              sx={{
                bgcolor: "rgba(255, 255, 255, 0.1)",
                borderRadius: 1,
              }}
            />
          </Box>
        </TextContent>

        <ImageContent>
          <Skeleton
            variant="rectangular"
            sx={{
              width: "100%",
              height: 400,
              maxWidth: 450,
              bgcolor: "rgba(255, 255, 255, 0.1)",
              borderRadius: 2,
              transform: {
                xs: "none",
                md: "perspective(1000px) rotateY(-12deg)",
              },
            }}
          />
        </ImageContent>
      </ContentWrapper>
    </SkeletonWrapper>
  );
};

export default HeroSkeleton;
